import { FormControlLabel, Switch } from '@mui/material'
import React from 'react'
import { i18n } from '../../domain/index'

interface Props {
  readonly isMuted: boolean
  readonly onChange: () => void
}

export function ToggleMuteButton({ isMuted, onChange: onClick }: Props) {
  return (
    <FormControlLabel
      control={<Switch checked={!isMuted} onChange={() => onClick()} />}
      label={i18n.t('admin.reminders.soundOn')}
      labelPlacement='start'
    />
  )
}
